export const exactItemsChecked = (items: string[], exactItems: number) => {
    return items && items.length === exactItems;
};

export const minItemsChecked = (items: string[], minItems: number) => {
    return items && items.length >= minItems;
};

export const maxItemsChecked = (items: string[], maxItems: number) => {
    return items && items.length <= maxItems;
};
